import React from 'react';
import cn from 'classname';
import _sumBy from 'lodash/sumBy';
import _find from 'lodash/find';

const TotalRow = (props) => {
	const { rows, dates, periodSwitch } = props;

	return (
		<tr className='total-row'>
			<td colSpan={1} className='total-title fixed-col fixed-col width-200'>Total</td>
			<td colSpan={8} className='total-title'></td>
			{
				dates.map((date, index) =>
					<DateCell rows={rows} date={date} key={index} periodSwitch={periodSwitch}/>
				)
			}
		</tr>
	);
};

const DateCell = props => {
	const { date, rows, periodSwitch } = props;
	const sumAbleRows = rows.filter(row => {

		const approved_count = Number(row[`approved_count_${date}`]) || 0;
		const non_trash_count = Number(row[`non_trash_count_${date}`]) || 0;

		const approveDiff =
			approved_count - Math.floor(non_trash_count * Number(row.target_percent || 0) / 100);
		const week_min_leads = _find(row.start_leads_setting, {
			start_duration : '7 days'
		});
		if (approveDiff > 0) {
			return false;
		}
		if (week_min_leads && week_min_leads.start_leads_count && periodSwitch !== 'month') {
			return non_trash_count >= Number(week_min_leads.start_leads_count);
		}
		if (week_min_leads && week_min_leads.start_leads_count && periodSwitch === 'month') {
			return non_trash_count >= Number(week_min_leads.start_leads_count) * 4;
		}
		return false;
	});
	const non_trash_count = _sumBy(sumAbleRows, row => Number(row[`non_trash_count_${date}`]) || 0);

	const usdPayout = _sumBy(
		sumAbleRows.filter(row => row.payouts && row.payouts.length),
		row => {
			const payout = Number(row.payouts.filter(r => r['usd'] > 0)[0].usd);
			const approved_count =  Number(row[`approved_count_${date}`]) || 0;
			const non_trash_count =  Number(row[`non_trash_count_${date}`]) || 0;
			const leadsToPay =
				(approved_count - Math.floor(non_trash_count * Number(row.target_percent || 0) / 100));
			return leadsToPay * payout;
		}
	);

	return (
		<td className={cn({'date-col': true, 'gray-background': false})}>
			<p>
				<span className="sub-col">{non_trash_count}</span>
				<span className="sub-col"></span>
				<span className="sub-col"></span>
				<span className="sub-col">{usdPayout}</span>
			</p>
		</td>
	);
};

export default TotalRow;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/components/table/total-row.js